export const UserStatuses = {
  ACTIVE: 'active',
  INACTIVE: 'inactive',
  LEAVE: 'leave',
} as const;

export type UserStatus = (typeof UserStatuses)[keyof typeof UserStatuses];

export const USER_STATUSES_LIST: UserStatus[] = [
  UserStatuses.ACTIVE,
  UserStatuses.INACTIVE,
  UserStatuses.LEAVE,
];
